export default "/static/webpack/media/question.315866fa.svg";